import { render, staticRenderFns } from "./GoogleAuthButton.vue?vue&type=template&id=666b8bd3"
import script from "./GoogleAuthButton.vue?vue&type=script&lang=js"
export * from "./GoogleAuthButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports